export enum TipoCliente {
    IVAExentoExportacion = 0,
    ResponsableInscripto = 1,
    //ResponsableInscriptoSinIVA = 2, se quita de circulacion (MB) 08/09/2022
    IVANoAlcanzado = 3,
    Exento = 4,
    ConsumidorFinal = 5,
    Monotributista = 6    
}